import _defineProperty from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style", "titleText", "subtitleText", "subtitleTextLink", "subtitleLink", "buttonText", "buttonIcon", "onButtonClick", "LinkComponent", "disabledFadeIn", "buttonLink", "scrollElement", "subtitleStyle", "fadeInAutoPlay", "textOnly", "isMobile", "ecosystem", "moveIcon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default, { Fragment } from 'react';
import styled from 'styled-components';
import '../../App.css.js';
import Action from '../actions/action.component.js';
import AnimationWrapper from '../animation/animation-wrapper.component.js';
import Button from '../buttons/button.component.js';
import Text from '../text/text.component.js';
var TextTitle = styled(Text).withConfig({
  displayName: "landing-header-normal-oldcomponent__TextTitle",
  componentId: "sc-gvaivt-0"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:64px;line-height:77px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "landing-header-normal-oldcomponent__TextDescription",
  componentId: "sc-gvaivt-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Medium,Arial;font-weight:500;font-size:24px;line-height:31px;}"]);
var LandingHeaderNormal = function LandingHeaderNormal(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    subtitleText = _ref.subtitleText,
    subtitleTextLink = _ref.subtitleTextLink,
    subtitleLink = _ref.subtitleLink,
    buttonText = _ref.buttonText,
    buttonIcon = _ref.buttonIcon,
    onButtonClick = _ref.onButtonClick,
    LinkComponent = _ref.LinkComponent,
    disabledFadeIn = _ref.disabledFadeIn,
    buttonLink = _ref.buttonLink,
    scrollElement = _ref.scrollElement,
    subtitleStyle = _ref.subtitleStyle,
    fadeInAutoPlay = _ref.fadeInAutoPlay,
    textOnly = _ref.textOnly,
    isMobile = _ref.isMobile,
    ecosystem = _ref.ecosystem,
    moveIcon = _ref.moveIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !disabledFadeIn,
    scrollElement: scrollElement,
    autoPlay: fadeInAutoPlay,
    fadeInDuration: "0.5s",
    fadeInDistance: "20px"
  }, /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "display",
    tag: "h1",
    fontSize: "xxlarge",
    style: {
      marginBottom: "0px",
      maxWidth: "100%",
      paddingLeft: "24px",
      paddingRight: "24px",
      boxSizing: "border-box",
      marginTop: "0px",
      textAlign: "center"
      /*opacity: 0,
      animationName: "textHeaderFadeIn",
      animationDuration: "1s",
      animationDelay: "1s",
      animationFillMode: "forwards",*/
    }
  }, titleText)), /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !disabledFadeIn,
    fadeInDuration: "0.5s",
    fadeInDelay: "0.2s",
    scrollElement: scrollElement,
    autoPlay: fadeInAutoPlay,
    fadeInDistance: "20px"
  }, /*#__PURE__*/React__default.createElement(TextDescription, {
    className: "subtitle-header",
    fontFamily: "euclid",
    type: "heading",
    fontSize: "xlargeM",
    color: "grey-1",
    style: _objectSpread({
      marginTop: "24px",
      textAlign: "center",
      maxWidth: "100%",
      paddingLeft: "24px",
      paddingRight: "24px",
      boxSizing: "border-box"
    }, subtitleStyle)
  }, subtitleText, " ", subtitleTextLink && subtitleLink && subtitleLink.lastIndexOf("http") >= 0 ? /*#__PURE__*/React__default.createElement("a", {
    href: subtitleLink,
    target: "_blank",
    title: subtitleTextLink,
    style: {
      color: "var(--green)"
    }
  }, subtitleTextLink) : subtitleTextLink ? /*#__PURE__*/React__default.createElement(LinkComponent, {
    to: subtitleLink,
    title: subtitleTextLink,
    style: {
      color: "var(--green)",
      textDecoration: "none"
    }
  }, subtitleTextLink) : null)), /*#__PURE__*/React__default.createElement(AnimationWrapper, {
    fadeIn: !disabledFadeIn,
    fadeInDuration: "0.5s",
    fadeInDelay: "0.4s",
    scrollElement: scrollElement,
    autoPlay: fadeInAutoPlay
    /*
    fadeInDistance={
      (typeof window != "undefined"
        ? window.innerHeight || document.documentElement.clientHeight
        : 0) *
        0.02 +
      "px"
    }
    */,

    fadeInDistance: "20px"
  }, textOnly ? /*#__PURE__*/React__default.createElement("div", {
    onClick: onButtonClick ? onButtonClick : null,
    style: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      marginTop: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(Action, {
    linkText: buttonText,
    LinkComponent: LinkComponent ? LinkComponent : null,
    color: "green",
    active: true,
    link: buttonLink ? buttonLink : null,
    linkIcon: buttonIcon ? buttonIcon : "chevron_down",
    forceHover: false,
    moveIcon: moveIcon ? moveIcon : null
  })) : buttonText ? /*#__PURE__*/React__default.createElement(Button, {
    type: "primary",
    color: "green",
    active: "true",
    borderRadiusType: "rounded",
    text: buttonText,
    textType: "large",
    width: "160px",
    icon: buttonIcon,
    iconPosition: "right",
    onClick: onButtonClick,
    LinkComponent: LinkComponent,
    link: buttonLink,
    heightButton: "xlarge",
    style: {
      //opacity: 0,
      marginTop: "34px"
      /*animationName: "textHeaderFadeIn",
      animationDuration: "1s",
      animationDelay: "1.4s",
      animationFillMode: "forwards",*/
    }
  }) : null));
};
export { LandingHeaderNormal as default };